// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"860eb73f","205":"36270e68","348":"964d4bca","615":"f918162d"}[chunkId] + ".chunk.js";
};